import { toast } from "react-toastify";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { setPostApiStatus } from "../../../actions/apiStatusActions";
import { SectionActionTypes, SectionActions } from "../../../actionTypes/permissions/sectionActionTypes";
import { addSectionApi, getSectionListApi } from "../../requests/permissions/sectionRequests";
import { setSectionList, setSectionListCount } from "../../../actions/permissions/sectionActions";





function* getSectionListHandler(action: SectionActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getSectionListApi, action.payload);
    if (data.status) {
      const dummyData = [
        {
          id: 0,
          name: "-",
          code: "-",
          description: "-"
        }
      ]
      yield put(setSectionList(data?.data?.rows || dummyData));
      yield put(setSectionListCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}


function* addSectionHandler(action: SectionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(addSectionApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}



// Section sagas
export default function* sectionSaga() {
  yield takeLatest(SectionActions.GET_SECTION_LIST, getSectionListHandler);
  yield takeLatest(SectionActions.ADD_SECTION, addSectionHandler);
}
